import { apiClient } from '@/libs/api'
import { type DcUsersRequestQuery } from '@/libs/api/types'

export type FetchDcUsersListQuery = {
  tenantKey: string
  query?: DcUsersRequestQuery
}

export const fetchDcUsers = async (
  { tenantKey, query }: FetchDcUsersListQuery,
  signal?: AbortSignal
) => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .dc_users.$get({
      query,
      config: {
        signal
      }
    })
  return { data, pagination }
}
